"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInChatContextProperties = void 0;
/**
 * Builds the Layer 2 (surface) + Layer 3 (in-chat + in-video-guide) auto-attach
 * block for any event fired inside an AI chat conversation.
 *
 * Each property is conditionally spread so a missing source value never
 * produces a `null`/`undefined` payload property — analytics queries that
 * filter on presence would otherwise treat absent and `null` differently.
 *
 * Used by every chat-domain event factory (`createChatEventCallbacks`,
 * `createModerationEventCallbacks`, …) so the auto-attach block has a single
 * point of definition. Adding a new Layer 3 field is a one-line change here
 * that propagates to every consumer.
 *
 * In-video-guide pair (`playing_content_id` / `playing_feature_media_id`) is
 * spread from the same helper because events fired inside an AI chat that is
 * itself rendered inside the Video Guide need both contexts on the payload.
 */
var buildInChatContextProperties = function (ctx) {
    var _a;
    return (__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), (ctx.chatSessionId && {
        chat_session_id: ctx.chatSessionId,
        // Emit explicit null when in a chat session whose title hasn't arrived
        // from Apollo cache yet, so analyst queries can distinguish "never had
        // a chat session" (property absent) from "in a chat session, title not
        // yet generated" (property present with null value). Spec: docs/analytics/design.md:103,452.
        conversation_title: (_a = ctx.conversationTitle) !== null && _a !== void 0 ? _a : null,
    })), (ctx.aiPersona && { ai_persona: ctx.aiPersona })), (ctx.chatExperienceName && { chat_experience_name: ctx.chatExperienceName })), (ctx.playingContentId != null && { playing_content_id: ctx.playingContentId })), (ctx.playingFeatureMediaId != null && { playing_feature_media_id: ctx.playingFeatureMediaId })), (function () {
        var _a;
        var t = (_a = ctx.getPlaybackState) === null || _a === void 0 ? void 0 : _a.call(ctx).currentTimeSeconds;
        return t != null ? { video_time_seconds: t } : {};
    })()));
};
exports.buildInChatContextProperties = buildInChatContextProperties;
